"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.formToDescription = void 0;
const formToDescription = (form, separator = '\n') => {
    const keyOrder = ['お名前', '会社名', 'メールアドレス', 'メッセージ'];
    const descriptions = keyOrder.map((key) => `${key}: ${form[key] || '-'}`);
    return descriptions.join(separator);
};
exports.formToDescription = formToDescription;
//# sourceMappingURL=formToDescription.js.map